"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AmountData = void 0;
var _react = _interopRequireDefault(require("react"));
var _definitions = require("@ppay/definitions");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../ui");
var _ticker = require("../../ticker");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var AmountValue = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme,
    $color = _ref.$color;
  return theme.colors[$color !== null && $color !== void 0 ? $color : 'tertiary'];
});
var TertiaryShadeText = (0, _styledComponents.default)(_ui.P)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-left: 3px !important;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.tertiaryShade;
});
var AmountData = function AmountData(_ref3) {
  var value = _ref3.value,
    convertedValue = _ref3.convertedValue,
    _ref3$convertedTicker = _ref3.convertedTicker,
    convertedTicker = _ref3$convertedTicker === void 0 ? _definitions.Ticker.USD : _ref3$convertedTicker,
    ticker = _ref3.ticker,
    positive = _ref3.positive,
    sign = _ref3.sign;
  return /*#__PURE__*/_react.default.createElement(_ui.P, {
    className: "d-inline-flex flex-wrap justify-content-end justify-content-md-start"
  }, /*#__PURE__*/_react.default.createElement(AmountValue, {
    $color: positive === undefined ? undefined : positive ? 'warning' : 'danger'
  }, sign, /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    value: value,
    ticker: ticker
  }), " ", ticker), convertedValue && /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, ' ≈ ', /*#__PURE__*/_react.default.createElement(_ticker.TickerSymbol, {
    ticker: convertedTicker
  }), ' ', /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    value: convertedValue,
    ticker: convertedTicker
  })));
};
exports.AmountData = AmountData;